import axios, { AxiosRequestConfig } from 'axios'
import { api_resources_overview_tag_path, api_resources_overview_tags_path } from '../routes'

export type ResourcesOverviewTagPayload = {
  name: string
  color: string
}

export function getResourcesOverviewTags() {
  const options: AxiosRequestConfig = {
    url: api_resources_overview_tags_path({ format: 'json' }),
    method: 'get',
    responseType: 'json',
  }

  return axios(options).then(response => response.data)
}

export function createResourcesOverviewTag(payload: ResourcesOverviewTagPayload) {
  const options: AxiosRequestConfig = {
    url: api_resources_overview_tags_path({ format: 'json' }),
    method: 'post',
    responseType: 'json',
    data: payload,
  }

  return axios(options).then(response => response.data)
}

export function updateResourcesOverviewTag(id: number, payload: ResourcesOverviewTagPayload) {
  const options: AxiosRequestConfig = {
    url: api_resources_overview_tag_path(id, { format: 'json' }),
    method: 'put',
    responseType: 'json',
    data: payload,
  }

  return axios(options).then(response => response.data)
}

export function deleteResourcesOverviewTag(id: number) {
  const options: AxiosRequestConfig = {
    url: api_resources_overview_tag_path(id, { format: 'json' }),
    method: 'delete',
    responseType: 'json',
  }

  return axios(options).then(response => response.data)
}
